import { cartStore } from '../cart/cart';
import { paymentStore } from '../payment/payment';

export default {
    getCouponData: (state) => (page) => {
        const storeCart = cartStore()
        const storePayment = paymentStore()

        let data = null
        if (page === 'cart') {
            data = storeCart.getCartCouponData()
        }
        else {
            data = storePayment.getAddressCouponData
        }
        return data;
    },

    getCouponCode: (state) => () => {
        return state.couponCode;
    }
}